<template>
    <div class="student-progress-content card-box-style rounded">
        <div class="main-title border-style d-flex justify-content-between align-items-center">
            <h3>Student's Progress</h3>

            <a href="#" class="view-btn">View All</a>
        </div>

        <ul class="student-list-wrap scroll-bar">
            <li 
                class="d-flex justify-content-between"
                v-for="student in students"
                :key="student.id"
            >
                <img :src="require(`../../../assets/images/${student.image}`)" alt="student-1">
                <div class="progress-wrap">
                    <div class="student-present d-flex justify-content-between">
                        <span class="student-name">{{student.name}}</span>
                        <span class="present">{{student.percent}}%</span>
                    </div>

                    <div :class="student.class">
                        <div 
                            class="progress-bar" 
                            role="progressbar" 
                            aria-label="Example with label" 
                            :style="{width: student.percent + '%'}" 
                            :aria-valuenow="student.percent" 
                            aria-valuemin="0" 
                            aria-valuemax="100"
                        >
                        </div>
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
import studentsProgress from './studentsProgress.json'

export default {
    name: 'StudentProgress',
    data (){
        return {
            students: studentsProgress,
        }
    }
}
</script>

<style lang="scss">
.student-progress-content {
	margin-bottom: 24px;
	&.card-box-style.rounded {
		padding-right: 5px;
		.student-list-wrap {
			padding-right: 15px;
		}
	}
	.main-title {
		margin-bottom: 25px;
	}
}
.student-list-wrap {
	padding-left: 0;
	margin-bottom: 0;
	list-style: none;
	li {
		margin-bottom: 22px;
		&:last-child {
			margin-bottom: 0;
		}
		.progress-wrap {
			width: 100%;
			margin-left: 15px;
			.student-present {
				margin-bottom: 20px;
				.student-name {
					font-size: 14px;
					font-weight: 500;
					color: var(--heading-color)
				}
				.present {
					font-size: 12px;
					font-weight: 700;
					color: var(--heading-color);
					position: relative;
					top: 12px;
				}
			}
			.progress {
				background-color: transparent;
				position: relative;
				z-index: 1;
				border-radius: 30px;
				--bs-progress-height: 10px;
				&::before {
					content: "";
					position: absolute;
					top: 3px;
					left: 0;
					width: 100%;
					height: 5px;
					background-color: #E2EAFB;
					z-index: -1;
					border-radius: 30px;
				}
				&.student-1 {
					&::before {
						background-color: #E5FFF2;
					}
					.progress-bar {
						background-color: #28C76F;
					}
				}
				&.student-2 {
					&::before {
						background-color: #F3EFFF;
					}
					.progress-bar {
						background-color: #5C31D6;
					}
				}
				&.student-3 {
					&::before {
						background-color: #FFFAEB;
					}
					.progress-bar {
						background-color: #FEC107;
					}
				}
				&.student-4 {
					&::before {
						background-color: #FFEEEE;
					}
					.progress-bar {
						background-color: #FE5957;
					}
				}
				.progress-bar {
					border-radius: 30px;
				}
			}
		}
	}
}

/* Min width 1400px to Max width 1700px */
@media only screen and (min-width: 1400px) and (max-width: 1700px) {
    .student-list-wrap {
        height: 340px;
        overflow: auto;
    }
}
</style>